<div [ngStyle]="{ 'display' : saamService.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="fields__block">
    <div class="fields__block__section">
      <div class="table-fields">
        <div>
          <div class="btn">
            <button type="submit" (click)="selectAll()" >Select All</button>
            <button type="submit" (click)="deselectAll()" >Deselect All</button>
          </div>
          <div class="scrollable">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th scope="col">Id</th>
                  <th scope="col">On Map</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let saam of saamService.saamFilterTableElems; let i = index" [class.highlighted]="saam.isselected">
                  <td><input type="checkbox" id="asbCheckbox_{{i}}" name="asbCheckbox_{{i}}" [(ngModel)]="saam.isselected"/></td>
                  <td>{{ saam.saamAirspace.name }}</td>
                  <td>{{ saam.saamAirspace.Id }}</td>
                  <td>{{ saam.onMap ? "On Map" : "Not On Map"  }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btn">
            <button type="submit" (click)="addToMap()">Add To Map</button>
            <button type="submit" (click)="removeSelectedFromMap()">Remove From Map</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
